import { Component, ViewChild, TemplateRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BeatListModel } from 'src/app/models/beat-list-model';
import { FilterListModel } from 'src/app/models/filter-list-model';
import { ShareModel } from 'src/app/models/share.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { FavoriteService } from 'src/app/services/favorite/favorite.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { environment } from 'src/environments/environment';
import { forkJoin } from 'rxjs';
import { NegotiationService } from 'src/app/services/negotiation/negotiation.service';
import { Router } from '@angular/router';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Component({
  selector: 'ipm-common-beats-dialog',
  templateUrl: './common-beats-dialog.component.html',
  styleUrls: ['./common-beats-dialog.component.scss']
})
export class CommonBeatsDialogComponent implements OnInit {
  @ViewChild('priceDialog', { static: false }) priceDialog: TemplateRef<any>;
  @ViewChild('sharedDialog', { static: false }) sharedDialog: TemplateRef<any>;
  @ViewChild('filterDialog', { static: false }) filterDialog: TemplateRef<any>;
  @ViewChild('downloadDialog', { static: false }) downloadDialog: TemplateRef<any>;
  @ViewChild('creditPurchase', { static: false }) creditPurchase: TemplateRef<any>;
  @ViewChild('lyricsDialog', { static: false }) lyricsDialog: TemplateRef<any>;
  @ViewChild('paymentSuccessPopup', { static: false }) paymentSuccessPopup: TemplateRef<any>;
  @ViewChild('basicCreditInfoDialog', { static: false }) basicCreditInfoDialog: TemplateRef<any>;
  @Output() nonLoginAlert: EventEmitter<boolean> = new EventEmitter();
  @Output() onTriggerPlayEvent: EventEmitter<any> = new EventEmitter();
  @Output() onTriggerSort: EventEmitter<any> = new EventEmitter();
  @Output() onTriggerNegotiation: EventEmitter<any> = new EventEmitter();
  @Input() isComponentType: string = "";
  @Input() genereFilter: Array<any> = [];
  lastPriceDialogData: any = null;
  currentUser: UserDetails;
  constructor(private commonService: CommonService,
    private beatService: BeatsService,
    private followService: FavoriteService,
    private userService: UserService,
    private authService: AuthService,
    private negotiationService: NegotiationService,
    private router: Router,
    private ga4Tracking: Ga4trackingService,
    private browserStorageService: BrowserStorageService ) {}

  ngOnInit(): void {
    this.authService.currentUserDetails.subscribe( res => {
      if (res &&  Object.keys(res).length > 0) {
        this.currentUser = res;
      }
    });

  }

  async openPriceDialog(beatObj: BeatListModel, selectedSlug:string = '', isCallingApi: string = "", renderType: string = "") {
    // Pass renderType to preparePricePopData so it can handle sound kits differently
    let data: any = this.beatService.preparePricePopData(beatObj, selectedSlug, '', renderType);
    
    // Add renderType to data so price component knows what to render
    data['renderType'] = renderType;
    
    if (isCallingApi && this.currentUser) {
      await this.negotiationService.getAllNegotiations().subscribe( res => {
        let negotiationList: any = res['buying'];
        if (negotiationList && negotiationList.length > 0) {
          let found: any = negotiationList.filter((item: any) =>  item.beatDetails?.id === beatObj._id);
          if (found && found.length) {
            if (found.length > 1) {
                let childFound = found.find((item: any) => item.isActive === true);
                if (childFound) {
                  data['negotiationObj'] = childFound;
                } else {
                  data['negotiationObj'] = found[0];
                }
            } else {
              data['negotiationObj'] = found[0];
            }
          }
        }
        data['negotiationAllow'] = false;
        if (beatObj.allow_negotiations) {
          data['negotiationAllow'] = true;
          if ((this.currentUser && this.currentUser.role === "producer") && this.currentUser._id === beatObj.created_by._id) {
            data['isShowBeatOwnerError'] = true;
          } else {
            data['isShowBeatOwnerError'] = false;
          }
        } else {
          data['isShowBeatOwnerError'] = false;
        }
        this.priceOpenDialog(data);
      }, (error) => {
         this.commonService.showToastError(error);
      });
    }  else {
      data['negotiationAllow'] = beatObj.allow_negotiations || false;
      this.priceOpenDialog(data);
    }

  }

  priceOpenDialog(data: any)  {
    this.lastPriceDialogData = data;
    let className = this.commonService.isMobileDisableClick ?  'mobile-view-price-model' : 'price-model';
    this.commonService.openModel(this.priceDialog,data,className);
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe( response => {
        this.openLoginAlertModel(response);
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe( response => {
        this.openLoginAlertModel(response);
      });
    }
  }

  soundPurchaseEventHandle($event: any) {
    if ($event) {
      this.commonService.closePopUp();
      this.soundPurchaseByCreditOpenDialog($event);
    }
  }

  soundPurchaseByCreditOpenDialog($event: any)  {
    let className = this.commonService.isMobileDisableClick ?  'mobile-view-sound-credit-model' : 'sound-credit-model';
    let sendData = {
      currentBeat: $event?.currentSound,
      currentLic: $event?.currentLic,
      availableCredits: $event?.availableCredits
    }
    this.commonService.openModel(this.creditPurchase, sendData,className);
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe( response => {
        this.openLoginAlertModel(response);
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe( response => {
        this.openLoginAlertModel(response);
    });
    }
  }

  openLoginAlertModel(res: any) {
    if (res === "login-alert") {
      this.nonLoginAlert.emit(true);
    } else if (res === "basic-credit-upgrade") {
      this.openBasicCreditInfoDialog();
    }
  }

  openBasicCreditInfoDialog() {
    let className = this.commonService.isMobileDisableClick ? 'mobile-view-basic-credit-info' : 'basic-credit-info';
    this.commonService.openModel(this.basicCreditInfoDialog, {}, className);
  }

  closeBasicCreditInfo() {
    this.commonService.closePopUp();
  }
  closeUpgradePlanPopup() {
    this.commonService.closePopUp();
    if (this.lastPriceDialogData) {
      this.priceOpenDialog(this.lastPriceDialogData);
    }
  }
  goToSubscriptionsFromCreditInfo() {
    this.commonService.closePopUp();
    this.router.navigate(['/subscriptions']);
  }

  /**
   * Share social app
   */
  openShareDialog(link: string, typeOfDialog: string ): void {
    let createLink: string = "";
    createLink = environment.shareUrl+link  ;
    let data: ShareModel = {
      link: createLink,
      type: typeOfDialog
    };
    let className = this.commonService.isMobileDisableClick ? 'mobile-view-share-model' : 'share-model';
    this.commonService.openModel(this.sharedDialog,data,className)
  }
  /**
   * Filter app
   */
  openFilterDialog(filterData: Array<FilterListModel>): void {
    let data: any = { filterList: filterData};
    let className = this.commonService.isMobileDisableClick ? 'mobile-view-filter-model' : 'filter-model';
    this.commonService.openModel(this.filterDialog,data,className);
  }

  /**
   * Open filter dialog with a specific tab pre-selected by index.
   */
  openFilterDialogAtTab(filterData: Array<FilterListModel>, tabIndex: number): void {
    let data: any = { filterList: filterData, activeTabIndex: tabIndex };
    let className = this.commonService.isMobileDisableClick ? 'mobile-view-filter-model' : 'filter-model';
    this.commonService.openModel(this.filterDialog, data, className);
  }


  openCommonDownloadModel(beatData:any) {
    let checkFollow =   this.followService.checkFollowProducer(beatData?.producer?._id);
    let followCount =  this.followService.getCountFollow(beatData?.producer?._id);
    let downloadCount =  this.userService.getMp3DownloadCount();
    let currentUser =  this.userService.getCurrentUserDetails();
    forkJoin([checkFollow, followCount, downloadCount, currentUser]).subscribe( res => {
      if (res &&  res.length > 0) {
        let [checkFollowRes, followCountRes, downloadCountRes, currentUserDataRes ] = res;
        let [followCount, beatCount, playCount] = followCountRes?.data;
        let sendData = {
          currentBeatData: beatData,
          isFollow: checkFollowRes.data,
          followCount:followCount?.value,
          playCountCount: playCount?.value.length > 0 ? playCount?.value[0]?.count : 0,
          trackCount: beatCount?.value,
          mp3DownloadCount: downloadCountRes?.freeDownloadAvailable,
          currentUser: Object.keys(currentUserDataRes).length > 0 ? currentUserDataRes : ''
        }
        let className = this.commonService.isMobileDisableClick ? 'mobile-ipm-view-download-model' : 'ipm-download-model';
        this.commonService.openModel(this.downloadDialog,sendData,className);
      }
    }, error => {
      this.commonService.showToastError(error);
    });
  }

  onChangePlayData(beatObj: BeatListModel) {
    this.onTriggerPlayEvent.emit(beatObj);
  }

  onTriggerNegotiationFn(beatObj: any) {
    this.onTriggerNegotiation.emit(beatObj);
  }

  sortEventTrigger(event: any) {
    if(event) {
      this.onTriggerSort.emit(event);
    }
  }

  showOrderPurchaseSuccess($event: any) {
    if ($event === "soundKitFree") {
      let message: string = "<p>Order Successfully Placed</p><p>This order was placed for free. You can now download your files</p>";
      this.paymentSuccess("soundFreeDownloadOrder", message);
    } else if ($event === "soundCreditPurchase") {
      let message: string = "<p>Order Successfully Paid via Credits</p><p>Your order has been completed using available credits. You can now download your files.</p>";
      this.paymentSuccess("soundCreditOrder", message);
    }
  }

  closePopup(event: any = "") {
    this.commonService.closePopUp();
    this.commonService.showToastSuccess("Order successful!");
    setTimeout(() => {
      this.commonService.cartDataList.next({});
       sessionStorage.setItem('orderSuccess', 'true');
      if (event.orderId) {
        this.router.navigate(['order-successful', event.orderId]);
      } else {
        this.router.navigate(['orders']);
      }
    }, 500);
  }

   paymentSuccess(type: string, messageData: string) {
    this.commonService.closePopUp();
    let sendData = {
      popType: type,
      buttonText: "Close",
      message: messageData
    }
    let classNotifyName =  this.commonService.getClassName('ipm-payment-success-popup-model');
    this.commonService.openModel(this.paymentSuccessPopup,sendData,classNotifyName,false);
    let eventName = "cart_checkout_successful"
    let attributes: any = {
      category: 'sound',
      label: type+'_order',  
      action: 'click',
      currency: 'INR'   ,
      userName: this.currentUser.name,
      userEmail: this.currentUser.email,
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest'
    };
    this.ga4Tracking.sendEvent(eventName, attributes);
    this.ga4Tracking.sendEvent('Purchase', attributes);
  }

  openLyricsEditor(beatObj: any, initialVersion?: number) {
    const className = this.commonService.isMobileDisableClick
      ? 'mobile-ipm-lyrics-pad-model' : 'ipm-lyrics-pad-model';
    this.commonService.openModel(this.lyricsDialog, { beat: beatObj, initialVersion }, className);
  }

}
